import Vue from 'vue';
import moment from 'moment';
import {authUtil} from '@/util/plugins'
import store from '@/store/store';

Vue.filter('date_fomater', (value, token) => {
	if (!value || !token) return '';
	return moment(value).format(token);
});

// 民國年
Vue.filter('date_fomater_roc', (value, token) => {
	if (!value || !token) return '';
	return moment(value).subtract(1911, 'years').format(token);
});

Vue.filter('date', (value) => {
	if (!value) return '';
	return moment(value).format('YYYY-MM-DD');
});

Vue.filter('date_mppg', (value) => {
	if (!value) return '';
	return moment(value, 'YYYYMMDDHHmmss').format('YYYY-MM-DD');
});

Vue.filter('dateTime', (value) => {
	if (!value) return '';
	return moment(value).format('YYYY-MM-DD hh:mm:ss');
});

Vue.filter('mdn', (value) => {
	if (!value) return '';
	return value.substr(0, 3) + "XXX" + value.substr(6);
})

Vue.filter('name', (value) => {
	if (!value) return '';
	if (authUtil.getIdentity(store.state.profile.pid) == 'personal') {
		if (value.length == 2) {
			return value[0] + "X";
		}
		else {
			return value[0] + 'X'.repeat(value.length - 2) + value[value.length - 1];
		}
	}
	else {
		return value;
	}
})

Vue.filter('identity', (value) => {
	if (!value) return '';
	if (authUtil.getIdentity(store.state.profile.pid) == 'personal') {
		return value.substr(0, 3) + "XXX" + value.substr(6);
	}
	return value
})

Vue.filter('address', (value) => {
	if (!value) return '';
	var reg = /^[\u4E00-\u9FA5]+$/;
	let preValue = '', postValue = '', pre = 0, post = 0;
	for (let index = 0, pre = 0; pre < 4; index++, pre++) {
		if (reg.test(value[index])) {
			pre++;
		}
		preValue += value[index];
	}
	for (let index = value.length - 1, post = 0; post < 4; index--, post++) {
		if (reg.test(value[index])) {
			post++;
		}
		postValue = value[index] + postValue;
	}
	return preValue + 'XXXXX' + postValue;
})



// WEBPACK FOOTER //
// ./src/filter/filter.js